module.exports = __webpack_public_path__ + "static/stealing-fire-ae859bae871282fa1c18b8185666bd8d.jpg";